import { formatMoney } from 'lib/functions/utils';
import {
  AmountSummaryHeader,
  AmountSummaryItem,
  AmountSummarySection,
} from 'pages/Finance/Components/Financing/common/Summary';
import React from 'react';

interface ResellSummaryCardProps {
  amount: number;
  advance: number;
  days: number;
  rateCost: number;
  operationCostFixed: number;
  operationCostVariable: number;
}

const ResellSummaryCard: React.FC<ResellSummaryCardProps> = ({
  amount,
  advance,
  days,
  rateCost,
  operationCostFixed,
  operationCostVariable,
}) => {
  const anticipatedAmount = Math.round((advance * amount) / 100);
  const operationCostWithIVA =
    (Number(operationCostFixed || 0) + Number(operationCostVariable || 0)) *
    1.19;
  const total = operationCostWithIVA + rateCost;

  const items: AmountSummaryItem[] = [
    {
      label: 'Monto a financiar',
      value: amount,
    },
    {
      label: `Monto anticipado (${advance}%)`,
      value: anticipatedAmount,
    },
    {
      label: `Costo tasa (${days} Dias)`,
      value: rateCost,
    },
    {
      label: 'Costo operacion + IVA',
      value: operationCostWithIVA,
      showDivider: true,
    },
    {
      label: 'Total',
      value: total,
      valueColor: 'primary.main',
    },
  ];

  return (
    <>
      <AmountSummaryHeader
        title="Resumen"
        totalAmount={total}
        formatMoney={formatMoney}
      />
      <AmountSummarySection items={items} formatMoney={formatMoney} />
    </>
  );
};

export default ResellSummaryCard;
